import { formatMoney as sharedFormatMoney } from "@KassaroAB/shared/utils/money";
import i18n from "i18next";
import type { Money } from "@KassaroAB/shared/types/money";

const languageToLocale: Record<string, string> = {
  sv: "sv-SE",
  en: "en-US",
};

const getLocale = (): string => {
  const lang = i18n.language?.split("-")[0] ?? "sv";
  return languageToLocale[lang] ?? languageToLocale.sv;
};

export const formatMoney = (money: Money | undefined | null): string => {
  if (!money) return "–";
  return sharedFormatMoney(getLocale(), money);
};
